export default __webpack_public_path__ + "static/media/nr.d3ed7990.jpg";